import React from "react";

const Home = props => {
  return <h1>Welcome to NBA Career Predictor!</h1>;
};

export default Home;
